import React, { Dispatch, SetStateAction, useState, useEffect } from "react";
import { contextFactory } from "../../../context/helpers/contextFactory";
import classes from "./Accordion.module.scss";

interface AccordionProps {
  children: JSX.Element | JSX.Element[];
  initialActiveItem: any;
  onActiveItemChange?: (activeItem: number) => void;
  className?: string;
}

interface AccordionContextProps {
  activeItem: string;
  setActiveItem: Dispatch<SetStateAction<string>>;
}

const [useAccordion, AccordionContext] =
  contextFactory<AccordionContextProps>();

export { useAccordion, AccordionContext };

export function Accordion({
  children,
  initialActiveItem,
  onActiveItemChange,
  className,
}: AccordionProps) {
  const [activeItem, setActiveItem] = useState(initialActiveItem);

  useEffect(() => {
    if (onActiveItemChange) {
      // we should not call this on initial mount since it already has a default value
      onActiveItemChange(activeItem);
    }
  }, [onActiveItemChange, activeItem]);

  return (
    <AccordionContext.Provider
      value={{
        activeItem,
        setActiveItem,
      }}
    >
      <div className={`${classes.accordion} ${className}`}>{children}</div>
    </AccordionContext.Provider>
  );
}
